import React, {Component} from 'react';
import {gpn} from "../GPN"
import req from "../req";
import config from "../config";

class Dashboard extends Component {

    state = {
        countUsers: "",
        countPayments: "",
        countOrders: "",
        sumToMonthPayments: 0,

        onlineUsers: []
    };

    componentDidMount() {
        req.get(`/statistics`)
            .then(r => {
                this.setState({
                    ...r
                });
                req.get(`/online-users`)
                    .then(r => {
                        let list = r ? r : [];
                        list = list ? list : [];
                        if (!Array.isArray(list)) list = [];
                        let final = list.map(it => {
                            try {

                                let arr = it.split("__");
                                let ip = arr[0];
                                let ua = "نامشخص";
                                if (arr.length >= 2) {
                                    ua = arr[1];
                                }
                                return {ip, ua};
                            } catch (err) {
                            }
                            return {ip: "", ua: ""};
                        });
                        this.setState({
                            onlineUsers: final
                        });
                    })
                    .catch(err => {
                        config.handleError(err);
                    });
            })
            .catch(err => {
                config.handleError(err);
            });

    }

    render() {
        let {
            countUsers, countPayments, countOrders, sumToMonthPayments,
            onlineUsers
        } = this.state;
        return (
            <div className="dashboard">
                <div className="row">
                    <div className="col-md-6">
                        <p>
                            <span>مجموع پرداخت های این ماه:</span><span>{config.priceFormatter(sumToMonthPayments)}&nbsp;تومان</span>
                        </p>
                    </div>
                    <div className="col-md-6">
                        <p><span>تعداد کل کاربران:</span><span>{config.priceFormatter(countUsers)}</span></p>
                    </div>
                    <div className="col-md-6">
                        <p><span>تعداد کل پرداخت ها:</span><span>{config.priceFormatter(countPayments)}</span></p>
                    </div>
                    <div className="col-md-6">
                        <p><span>تعداد کل سفارشات:</span><span>{config.priceFormatter(countOrders)}</span></p>
                    </div>
                </div>
                <br/>
                <div className="online-users">
                    <h3>کلاینت های آنلاین</h3>
                    <div className="list">
                        {
                            onlineUsers?.map((u, i) =>
                                <article key={"ou" + i}>
                                    <div className="row">
                                        <div className="col-auto">
                                            <div className="ip">{u.ip || "نامشخص"}</div>
                                        </div>
                                        <div className="col">
                                            <div className="ua">{u.ua || "نامشخص"}</div>
                                        </div>
                                    </div>
                                </article>
                            )
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default gpn(Dashboard);